module.exports = __webpack_public_path__ + "static/media/ticket-processed.46fedd32.svg";